import axiosInstance from "../../../setupAxios";
import { IUsageGroupResult, IUsageGroupsSearchResult } from "../../types/usageTypes/IUsageGroupsSearchResult";
import { IUsagesSearchQuery } from "../../types/usageTypes/IUsagesSearchQuery";
import { IMatchWorksSearchResult } from "../../types/usageTypes/IMatchWorksSearchResult";
import { IMatchWorksSearchQuery } from "../../types/usageTypes/IMatchWorksSearchQuery";
import { Dispatch } from "redux";
import { REPERTOIRE, CONFIGURATION_PARAMETER_USAGE_MAINTENANCE_GROUP, USAGE_MAINTENANCE_KEY, AVSeasonCode, AVEpisode, CONFIGURATION_PARAMETER_SORT_USAGE_WRITER_TYPE, AVProductionYear, USAGE_SEARCH_SOURCE_COSMOS } from "../../Consts";
import { IUsageMatch } from "../../types/usageTypes/IUsageMatch";
import { getUsageMatchesFailure, getUsageMatchesSuccess, searchUsageGroupFailure, searchUsageGroupSuccess } from "../../../redux/reducers/RepertoireReducer";
import { hideModal } from "../../../redux/reducers/ModalReducer";
import { UsageDetailsMapper } from "./UsageDetailsMapper";
import { IProductSearchQuery } from "../../types/IProductSearchQuery";
import { IProductSearchResult } from "../../types/IProductSearchResult";
import { SearchRequests } from "../SearchRequests";
import { IMatchProductsSearchQuery } from "../../../repertoire/types/usageTypes/IMatchProductsSearchQuery";
import { startCase } from "lodash";
import { ITreeData } from "../../types/ITreeData";
import { RepertoireHelper } from "../RepertoireHelper";

export class UsageSearchRequests {

    public static getUsages(
        searchQuery: IUsagesSearchQuery,
        sources: ITreeData[],
        continuationToken?: string
    ): Promise<IUsageGroupsSearchResult> {
        const {
            usageType,
            searchSource = USAGE_SEARCH_SOURCE_COSMOS,
            type,
            distribution,
            pool,
            fileName,
            title,
            composer,
            artist,
            sourceMajor,
            sourceMinor,
            rightShareOwner,
            allocationStatus,
            includeFeesInError,
            totalWeight,
            licenseesWorkNumber,
            matchStatus,
            hasOpenWorkflow,
            matchID,
            titleContains,
            distributionsFilter,
            sourcesFilter,
            approvalStatus,
            qaStatus,
            estimatedValue,
            estimatedFromValue,
            estimatedToValue,
            productType,
            performanceNumberType,
            performanceNumber,
            fromDate,
            toDate,
            usageUse,
            programName,
            carrierType,
            dimension1,
            dimension2,
            dimension3,
            dimension4,
            dimension5,
            venueName,
            ipName,
            ipiNameNumber,
            pageSize,
            licensingSystemID,
            artistNameAdvancedSearch,
            customerCodeAdvancedSearch,
            venueCodeAdvancedSearch
        } = searchQuery;
        return new Promise<IUsageGroupsSearchResult>((resolve, reject) => {
            axiosInstance
                .post("/Search/Usages", {
                    usageType: {
                        value: usageType.replace(/\s/g, ""),
                        type: 0
                    },
                    searchSource: {
                        value: searchSource,
                        type: 0
                    },
                    type: {
                        value: type ? (type.split(" ")).join("") : type,
                        type: 0
                    },
                    distribution: {
                        value: distribution,
                        type: 0
                    },
                    pool: {
                        value: pool,
                        type: 0
                    },
                    fileName: {
                        value: fileName,
                        type: 0
                    },
                    title: {
                        value: title,
                        type: 0
                    },
                    composer: {
                        value: composer,
                        type: 0
                    },
                    artist: {
                        value: artist,
                        type: 0
                    },
                    sourceMajor: {
                        value: sourceMajor,
                        type: 0
                    },
                    sourceMinor: {
                        value: sourceMinor,
                        type: 0
                    },
                    rightShareOwner: {
                        value: rightShareOwner,
                        type: 0
                    },
                    allocationStatus: {
                        value: allocationStatus,
                        type: 0
                    },
                    includeFeesInError: {
                        value: includeFeesInError,
                        type: 2
                    },
                    totalWeight: {
                        value: totalWeight,
                        type: 0
                    },
                    licenseesWorkNumber: {
                        value: licenseesWorkNumber,
                        type: 0
                    },
                    matchStatus: {
                        value: matchStatus,
                        type: 0
                    },
                    hasOpenWorkflow: {
                        value: hasOpenWorkflow,
                        type: 2
                    },
                    matchID: {
                        value: matchID,
                        type: 0
                    },
                    distributionsFilter: {
                        value: distributionsFilter,
                        type: 0
                    },
                    titleContains: {
                        value: titleContains,
                        type: 0
                    },
                    sourcesFilter: {
                        value: sourcesFilter,
                        type: 0
                    },
                    approvalStatus: {
                        value: approvalStatus,
                        type: 0
                    },
                    qaStatus: {
                        value: qaStatus,
                        type: 0
                    },
                    continuationToken: continuationToken,
                    estimatedValue:{
                        value: estimatedValue,
                        type: 0
                    },
                    estimatedFromValue:{
                        value: estimatedFromValue,
                        type: 0
                    },
                    estimatedToValue:{
                        value: estimatedToValue,
                        type: 0
                    },
                    productType: {
                        value: productType,
                        type: 0
                    },
                    performanceNumberType: {
                        value: performanceNumberType,
                        type: 0
                    },
                    performanceNumber: {
                        value: performanceNumber,
                        type: 0
                    },
                    fromDate: {
                        value: fromDate,
                        type: 0
                    },
                    toDate: {
                        value: toDate,
                        type: 0
                    },
                    usageUse : {
                        value: usageUse,
                        type: 0
                    },
                    programName : {
                        value: programName,
                        type: 0
                    },
                    carrierType : {
                        value: carrierType,
                        type: 0
                    },
                    dimension1 : {
                        value: dimension1,
                        type: 0
                    },
                    dimension2 : {
                        value: dimension2,
                        type: 0
                    },
                    dimension3 : {
                        value: dimension3,
                        type: 0
                    },
                    dimension4 : {
                        value: dimension4,
                        type: 0
                    },
                    dimension5 : {
                        value: dimension5,
                        type: 0
                    },
                    venueName : {
                        value: venueName,
                        type: 0
                    },
                    ipName : {
                        value: ipName,
                        type: 0
                    },
                    ipiNameNumber : {
                        value: ipiNameNumber,
                        type: 0
                    },
                    licensingSystemID : {
                         value: licensingSystemID,
                        type: 0
                    },
                    artistNameAdvancedSearch : {
                         value: artistNameAdvancedSearch,
                        type: 0
                    },
                    customerCodeAdvancedSearch : {
                         value: customerCodeAdvancedSearch,
                        type: 0
                    },
                    venueCodeAdvancedSearch : {
                         value: venueCodeAdvancedSearch,
                        type: 0
                    },
                    pageSize: pageSize
                })
                .then(async response => {
                    const usageSearchResultItems: IUsageGroupsSearchResult = {
                        continuationToken: response.data.continuationToken,
                        usageGroups: []
                    };
                    try {
                        const configValue = await this.getConfigurationParameter(USAGE_MAINTENANCE_KEY, CONFIGURATION_PARAMETER_USAGE_MAINTENANCE_GROUP);

                        for (let x = 0; x < response.data.usageGroups.length; x++) {
                            const usageGroup = response.data.usageGroups[x];
                            let allocationStatus = 'Not Allocated';

                            if (usageGroup?.allocations?.length && usageGroup.allocations.length > 0) {
                                allocationStatus = 'Allocated';
                            }

                            let usageSearchResultItem: IUsageGroupResult = {
                                id: usageGroup.id,
                                title: usageGroup.fullTitle,
                                distributionCode: usageGroup.distributionCode,
                                poolCode: usageGroup.poolCode,
                                source: (this.getSourceHierarchy(usageGroup.sourceMajor, usageGroup.sourceMinor, sources)).replace("Global/", ""),
                                matchStatus: startCase(usageGroup.matchStatus),
                                allocationStatus: allocationStatus,
                                qaStatus: usageGroup.qaStatus,
                                number: usageGroup.usageSearch && usageGroup.usageSearch.performanceNumbers && configValue?.PerformanceNumberTypes
                                    ? [
                                        ...new Set(
                                            configValue.PerformanceNumberTypes.map(typeCode =>
                                                usageGroup.usageSearch.performanceNumbers.find(item => item.typeCode === typeCode)?.number
                                            ).filter(Boolean)
                                        )
                                    ].join(' / ') || ''
                                    : '',
                                weight: usageGroup.totalWeightString,
                                matches: usageGroup.matches,
                                performanceNumbers: (usageGroup?.usageSearch?.performanceNumbers ?? []).map((pn: any) => ({
                                    typeCode: pn?.typeCode ?? "",
                                    number: pn?.number ?? ""
                                })),
                                sourceMajor: usageGroup.sourceMajor,
                                sourceMinor: usageGroup.sourceMinor,
                                productType: usageGroup.productType,
                                artist: usageGroup.fullPerformer,
                                composer: usageGroup.fullContributor
                            }
                            usageSearchResultItems.usageGroups.push(usageSearchResultItem);
                        }
                        resolve(usageSearchResultItems);
                    }
                    catch (error) {
                        console.error("Error fetching configuration parameter:", error);
                    }

                    
                })
                .catch(res => {
                    reject(res);
                });
        })
    }

    private static getSourceHierarchy(sourceMajor: string, sourceMinor: string, sources: ITreeData[]) {
       return `${sourceMajor && sourceMajor}${sourceMinor && `/${sourceMinor}`}`;
    }

    public static getUsage(usageID: string): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .get("/usage/id/" + usageID)
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err.response.status);
                });
        });
    }

    public static getWork(dataSource: string, workID: number): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .get("/work/" + dataSource + '/' + workID)
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err.response.status);
                });
        });
    }

    public static getConfigurationParameter(key: string, group: string): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .get("/Component/ConfigurationParameter/" + key + "/" + group)
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err.response.status);
                });
        });
    }

    public static getWorks(
        searchQuery: IMatchWorksSearchQuery
    ): Promise<IMatchWorksSearchResult[]> {
        const {
            workIDs,
            title,
            number,
            artist,
            writers,
            societyAccountNumber,
            dataSource,
            workBatchID,
            hasOpenWorkflow
        } = searchQuery;
        return new Promise<IMatchWorksSearchResult[]>((resolve, reject) => {
            axiosInstance
                .post("/search/works", {
                    workIDs: {
                        values: workIDs.map(id => { return { value: id, type: 2 } })
                    },
                    title: {
                        value: title,
                        type: 0
                    },
                    number: {
                        value: number,
                        type: 0
                    },
                    artist: {
                        value: artist,
                        type: 0
                    },
                    contributor: {
                        value: writers,
                        type: 0
                    },
                    societyAccountNumber: {
                        value: societyAccountNumber,
                        type: 0
                    },
                    workBatchID: {
                        value: (isNaN(parseInt(workBatchID))) ? workBatchID: parseInt(workBatchID),
                        type: 2
                    },
                    dataSource: dataSource,
                    hasOpenWorkflow: {
                        value: hasOpenWorkflow,
                        type: 2
                    },
                    includeIsReplacedWorks: true
                })
                .then(async response => {
                    const workSearchResultItems: IMatchWorksSearchResult[] = [];
                    const configValueOrder = await this.getConfigurationParameter(CONFIGURATION_PARAMETER_SORT_USAGE_WRITER_TYPE, CONFIGURATION_PARAMETER_USAGE_MAINTENANCE_GROUP);
                    for (let x = 0; x < response.data.length; x++) {
                        const data = response.data[x];

                        let workSearchResultItem: IMatchWorksSearchResult = {
                            title: [],
                            titleTypeCodes: [],
                            number: [],
                            writers: [],
                            publishers: [],
                            artists: [],
                            compoundType: data.medleyType ? data.medleyType : '',
                            workID: response.data[x].workID,
                            contributors: [],
                            dataSource: dataSource,
                            duration: data.duration,
                            workStatus: []
                        }

                        for (let x = 0; x < 3; x++) {
                            if (data.workNames[x]) {
                                workSearchResultItem.title.push(data.workNames[x].name)
                                workSearchResultItem.titleTypeCodes.push(data.workNames[x].type)
                            }

                            if (data.workNumbers[x]) {
                                workSearchResultItem.number.push(data.workNumbers[x].number)
                            }

                            if (data.performers[x]) {
                                workSearchResultItem.artists.push(data.performers[x].fullName)
                            }
                            if(data.workTerritorySpecificInfo && data.workTerritorySpecificInfo[x]){
                                workSearchResultItem.workStatus.push(data.workTerritorySpecificInfo[x].workStatus)
                            }
                        }

                        if (data.contributors) {
                            const writers = data.contributors.filter(c => c.contributorType === 'Writer');
                            writers.sort((a, b) => {
                                let aIndex = configValueOrder.indexOf(a.type);
                                let bIndex = configValueOrder.indexOf(b.type);

                                if (aIndex === -1) aIndex = 999;
                                if (bIndex === -1) bIndex = 999;

                                return aIndex - bIndex;
                            });
                            for (let x = 0; x < writers.length && workSearchResultItem.writers.length < 3; x++) {
                                if (writers[x].ipiNumber)
                                    workSearchResultItem.writers.push(writers[x].fullName + ' (' + writers[x].ipiNumber.toString().padStart(11, '0') + ')');
                                else
                                    workSearchResultItem.writers.push(writers[x].fullName);
                            }
                            for (let x = 0; x < data.contributors.length; x++) {
                                if (data.contributors[x].contributorType === 'Publisher' && workSearchResultItem.publishers.length < 3) {
                                    if(data.contributors[x].ipiNumber)
                                        workSearchResultItem.publishers.push(data.contributors[x].fullName + ' (' + data.contributors[x].ipiNumber.toString().padStart(11,'0') + ')')
                                    else
                                        workSearchResultItem.publishers.push(data.contributors[x].fullName)
                                }
                            }
                        }

                        workSearchResultItems.push(workSearchResultItem);
                    }

                    resolve(workSearchResultItems);
                })
                .catch(res => {
                    reject(res);
                });
        });
    }

    public static getWorksByIdList(
        searchQuery: IMatchWorksSearchQuery
    ): Promise<IMatchWorksSearchResult[]> {
        const {
            workIDs,
            title,
            number,
            artist,
            writers,
            societyAccountNumber,
            dataSource,
            workBatchID,
            hasOpenWorkflow
        } = searchQuery;
        return new Promise<IMatchWorksSearchResult[]>((resolve, reject) => {
            axiosInstance
              .post("/search/WorkUsageMatches", {
                    workIDs: {
                        values: workIDs.map(id => { return { value: id, type: 2 } })
                    },
                    title: {
                        value: title,
                        type: 0
                    },
                    number: {
                        value: number,
                        type: 0
                    },
                    artist: {
                        value: artist,
                        type: 0
                    },
                    contributor: {
                        value: writers,
                        type: 0
                    },
                    societyAccountNumber: {
                        value: societyAccountNumber,
                        type: 0
                    },
                    workBatchID: {
                        value: workBatchID,
                        type: 2
                    },
                    dataSource: dataSource,
                    hasOpenWorkflow: {
                        value: hasOpenWorkflow,
                        type: 2
                    },
                })
                .then(response => {
                    const workSearchResultItems: IMatchWorksSearchResult[] = [];

                    for (let x = 0; x < response.data.length; x++) {
                        const data = response.data[x];

                        let workSearchResultItem: IMatchWorksSearchResult = {
                            title: [],
                            number: [],
                            writers: [],
                            publishers: [],
                            artists: [],
                            contributors: [],
                            compoundType: data.medleyType ? data.medleyType : '',
                            workID: response.data[x].workID,
                            dataSource: dataSource,
                            duration: data.duration
                        }

                        for (let x = 0; x < 3; x++) {
                            if (data.workNames[x]) {
                                workSearchResultItem.title.push(data.workNames[x].name)
                            }

                            if (data.workNumbers[x]) {
                                workSearchResultItem.number.push(data.workNumbers[x].number)
                            }

                            if (data.performers[x]) {
                                workSearchResultItem.artists.push(data.performers[x].fullName)
                            }
                        }

                        if (data.contributors) {
                            for (let x = 0; x < data.contributors.length; x++) {
                                if (data.contributors[x].contributorType === 'Writer' && workSearchResultItem.writers.length < 3) {
                                    workSearchResultItem.writers.push(data.contributors[x].fullName)
                                }
                                if (data.contributors[x].contributorType === 'Publisher' && workSearchResultItem.publishers.length < 3) {
                                    workSearchResultItem.publishers.push(data.contributors[x].fullName)
                                }
                                if (data.contributors[x]) {
                                    workSearchResultItem.contributors.push(data.contributors[x])
                                }
                            }
                        }

                        workSearchResultItems.push(workSearchResultItem);
                    }

                    resolve(workSearchResultItems);
                })
                .catch(res => {
                    reject(res);
                });
        });
    }

    public static getProducts(
        searchQuery: IMatchProductsSearchQuery
    ): Promise<IProductSearchResult[]> {
        const {
            productIDs,
            artist,
            contributor,
            dataSource,
            number,
            productBatchID,
            title,
            productType
        } = searchQuery;
        return new Promise<IProductSearchResult[]>((resolve, reject) => {
            axiosInstance
                .post("/Search/ProductUsageMatches", {
                    productIDs: {
                        values: productIDs.map(id => { return { value: id, type: 2 } })
                    },
                    type: {
                        value: productType,
                        type: 1
                    },
                    title: {
                        value: title,
                        type: 0
                    },
                    number: {
                        value: number,
                        type: 0
                    },
                    contributor: {
                        value: contributor,
                        type: 0
                    },
                    artist: {
                        value: artist,
                        type: 0
                    },
                    productBatchID: {
                        value: (isNaN(parseInt(productBatchID))) ? productBatchID: parseInt(productBatchID),
                        type: 2
                    },
                    dataSource: dataSource
                })
                .then(response => {
                    const productSearchResultItems: IProductSearchResult[] = [];

                    for (let x = 0; x < response.data.length; x++) {
                        const data = response.data[x];
                        const season = data.productNumbers.filter((item) => item.productNumberType === AVSeasonCode).length > 0 
                            ? data.productNumbers.filter((item) => item.productNumberType === AVSeasonCode)[0].number
                            : "NA";

                        const episode = data.productNumbers.filter((item) => item.productNumberType === AVEpisode).length > 0 
                            ? data.productNumbers.filter((item) => item.productNumberType === AVEpisode)[0].number
                            : "NA";

                        const yearOfProduction = data.productNumbers.filter((item) => item.productNumberType === AVProductionYear).length > 0
                            ? data.productNumbers.filter((item) => item.productNumberType === AVProductionYear)[0].number
                            : "NA";

                        let productSearchResultItem: IProductSearchResult = {
                            productCoreID: data.productCoreID,
                            dataSource: dataSource,
                            type: data.productType,
                            id1: data.id1,
                            id2: data.id2 ? data.id2 : '',
                            number: [],
                            title: [],
                            episode: `${season}-${episode}`,
                            source: data.source,
                            artist: [],
                            contributor: [],
                            productionType:data.productionType ? data.productionType: '' ,
                            musicDuration: data.musicDuration ? [data.musicDuration] : [],
                            yearOfProduction: yearOfProduction,
                            worksCount: data.worksCount ? data.worksCount : 0,
                        }

                        for (let x = 0; x < 3; x++) {
                            if (data.productNames[x]) {
                                var type = data.productNames[x].productNameType
                                productSearchResultItem.title.push(data.productNames[x].name + " (" + type + ")")
                            }

                            if (data.productPerformers[x]) {
                                productSearchResultItem.artist.push(data.productPerformers[x].performerName)
                            }

                            if (data.productNumbers[x]) {
                                productSearchResultItem.number.push(data.productNumbers[x].number)
                            }

                            if (data.productContributors[x]) {
                                productSearchResultItem.contributor.push(data.productContributors[x].name)
                            }
                        }

                        productSearchResultItems.push(productSearchResultItem);
                    }
                    resolve(productSearchResultItems);
                })
                .catch(res => {
                    reject(res);
                });
        })
    }

    public static async searchMatchingWorks(usageGroupsSearchResult: IUsageGroupsSearchResult, searchBody: IUsagesSearchQuery, dispatch: Dispatch, modalOpen: boolean, continuationToken?: string, startIndex?: number, endIndex?: number) {

        let workIDs = new Set<number>();
        
        for (let i = 0; i < usageGroupsSearchResult.usageGroups.length; i++) {
            if (!usageGroupsSearchResult.usageGroups[i].matches?.length) continue;
            for (let j = 0; j < usageGroupsSearchResult.usageGroups[i].matches.length; j++) {
                if (usageGroupsSearchResult.usageGroups[i].matches[j].id === 0) continue;
                workIDs.add(usageGroupsSearchResult.usageGroups[i].matches[j].id);
            }
        }
        
        if(workIDs.size > 0){
            await UsageSearchRequests.workSearchQuery([ ...workIDs ], usageGroupsSearchResult, dispatch, modalOpen, continuationToken, startIndex)
        }

    }

    public static async workSearchQuery(workIDs: number[], usageGroupsSearchResult: IUsageGroupsSearchResult, dispatch: Dispatch, modalOpen: boolean, continuationToken?: string, startIndex?: number) {
        const searchQuery: IMatchWorksSearchQuery =
        {
            workIDs: workIDs,
            title: "",
            number: "",
            artist: "",
            writers: "",
            societyAccountNumber: "",
            workBatchID: "",
            dataSource: REPERTOIRE,
            hasOpenWorkflow: false
        };

        await UsageSearchRequests.getWorksByIdList(searchQuery)
            .then((worksResult: IMatchWorksSearchResult[]) => {
                for (let i = 0; i < usageGroupsSearchResult.usageGroups.length; i++) {
                    if (usageGroupsSearchResult.usageGroups[i].matches === null) continue;
                    for (let j = 0; j < usageGroupsSearchResult.usageGroups[i].matches.length; j++) {
                        const work: IMatchWorksSearchResult = worksResult.find(y => y.workID === usageGroupsSearchResult.usageGroups[i].matches[j].id);
                        if (work !== undefined) {
                            usageGroupsSearchResult.usageGroups[i].matches[j].numbers = work.number;
                            usageGroupsSearchResult.usageGroups[i].matches[j].performers = work.artists;
                            usageGroupsSearchResult.usageGroups[i].matches[j].titles = work.title;
                            usageGroupsSearchResult.usageGroups[i].matches[j].composers = work.writers;
                        }
                    }
                }
            })
            .catch(err => {
                dispatch(hideModal());
                // Dont error usage search results if work retrieval fails
                //dispatch(getUsageMatchesFailure(err));
            });
    }


    public static async searchMatchingProducts(usageGroupsSearchResult: IUsageGroupsSearchResult, searchBody: IUsagesSearchQuery, dispatch: Dispatch, modalOpen: boolean, continuationToken?: string) {

        let productIDs = new Set<number>();
        productIDs.add(-1);

        for (let i = 0; i < usageGroupsSearchResult.usageGroups.length; i++) {
            if (!usageGroupsSearchResult.usageGroups[i].matches?.length) continue;
            for (let j = 0; j < usageGroupsSearchResult.usageGroups[i].matches.length; j++) {
                    if(usageGroupsSearchResult.usageGroups[i].matches[j].id === 0) continue;
                    productIDs.add(usageGroupsSearchResult.usageGroups[i].matches[j].id);
            }
        }

        await UsageSearchRequests.productSearchQuery([ ...productIDs ], usageGroupsSearchResult, dispatch, modalOpen, continuationToken)
    }

    public static async productSearchQuery(productIDs: number[], usageGroupsSearchResult: IUsageGroupsSearchResult, dispatch: Dispatch, modalOpen: boolean, continuationToken?: string) {
        const searchQuery: IProductSearchQuery =
            {
                productIDs: productIDs,
                productType: "",
                title: "",
                number: "",
                contributor: "",
                artist: "",
                dataSource: REPERTOIRE,
                productBatchID: ""
            };

            await UsageSearchRequests.getProducts(searchQuery)
                .then((productsResult: IProductSearchResult[]) => {
                    for (let i = 0; i < usageGroupsSearchResult.usageGroups.length; i++) {
                        if (usageGroupsSearchResult.usageGroups[i].matches === null) continue;
                        for (let j = 0; j < usageGroupsSearchResult.usageGroups[i].matches.length; j++) {
                            const product: IProductSearchResult = productsResult.find(y => y.productCoreID === usageGroupsSearchResult.usageGroups[i].matches[j].id);
                            if (product !== undefined) {
                                const matchNumbers: string[] = []
                                matchNumbers.push(product.id1);
                                matchNumbers.push(product.id2);
                                usageGroupsSearchResult.usageGroups[i].matches[j].numbers = matchNumbers;
                                usageGroupsSearchResult.usageGroups[i].matches[j].titles = product.title;
                                usageGroupsSearchResult.usageGroups[i].matches[j].performers = product.artist;
                                usageGroupsSearchResult.usageGroups[i].matches[j].composers = product.contributor;
                            }
                        }
                    }
                })
                .catch(err => {
                    dispatch(hideModal());
                    // Dont error usage search results if work retrieval fails
                    //dispatch(getUsageMatchesFailure(err));
                });
    }


}
